module.exports = { "default": require("core-js/library/fn/object/get-own-property-descriptor"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ../~/_babel-runtime@6.26.0@babel-runtime/core-js/object/get-own-property-descriptor.js
// module id = 946
// module chunks = 0